<template>
  <div class="bindDiv">
    <el-dialog title="考宝学涯用户协议" lock-scroll :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="showAgreement" :modal-append-to-body="false" :width="'98%'">
      <agreement></agreement>
      <el-button type="success" @click="showAgreement = false">我明白了</el-button>
    </el-dialog>

    <div v-show="!showAgreement">
      <!--手机账号绑定-->
      <div>
        <div class="phoneDiv" style="margin-top: 10px">
          <div style="width: 98%; padding-left: 1%; padding-right: 1%">
            <div class="bindTx">
              <span>
                报名及表明同意
                <U style="margin: 0px; color: red" @click="showAgreement = true">用户协议和隐私政策</U>
              </span>
            </div>
            <!-- <p v-if="$store.state.RegisterPhone == 3">学校数据有误，请重新填写</p> -->
            <div id="phoneNum" v-if="$store.state.RegisterPhone !== 3">
              <yd-cell-item>
                <yd-input slot="right" v-model="telNum" regex="^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$" placeholder="请输入手机号码.."
                  :disabled="isGetPhone"></yd-input>
              </yd-cell-item>
            </div>
            <div id="Verification" v-if="$store.state.RegisterPhone !== 3">
              <div class="VerificationInput">
                <yd-cell-item>
                  <yd-input v-model="verifiCode" slot="right" :show-success-icon="false" :show-error-icon="false"
                    max="4" placeholder="请输入验证码"></yd-input>
                </yd-cell-item>
              </div>
              <div class="VerificationBtn" v-show="verifiFlag == 60" @click="getVerification">
                获取验证码
              </div>
              <div class="VerificationBtn" v-show="verifiFlag < 60">
                {{ verifiFlag }}
              </div>
            </div>
          </div>
        </div>

        <div class="phoneDiv" style="margin-top: 10px">
          <div class="sele" @click="
            showChooseNew = true;
          showArea = true;
          ">
            <div class="myChose">
              {{
                  selectedSchool && selectedSchool.Schoolname
                    ? selectedSchool.Schoolname
                    : "选择就读高中"
              }}
            </div>
            <img class="myup" src="../../static/zsbImg/upimg.png" alt />
          </div>

          <div class="sele" @click="choseTime()">
            <div class="myChose">
              {{ form.joinTime ? form.joinTime + "年" : "请选择高中入学时间" }}
            </div>
            <img class="myup" src="../../static/zsbImg/upimg.png" alt />
          </div>
          <van-checkbox v-model="agreeShareContact" checked-color="#07c160" style="
              width: 80%;
              margin-left: 10%;
              margin-top: 15px;
              color: #cccccc;
              width: 100%;
              margin-left: 1%;
            ">
            <!--  我同意把我的号码提供给我报名活动的院校招办 -->
            <a style="color: #aaaaaa">同意已报名参加活动的高校招办查询我的报名信息</a>
          </van-checkbox>
          <div id="jionIn">
            <!-- <van-button @click="bindPhone" type="primary">完成绑定</van-button> -->
            <yd-button size="large" @click.native="bindPhone" type="primary" v-preventReClick="2000">完成</yd-button>
          </div>
        </div>
      </div>

      <!--提示信息-->
      <div class="mydialog" v-show="gaoxiao">
        <div class="content">
          <p>您是高校对接人</p>
          <div>可以在“我的”－“合作高校”中查看合作高校哦</div>
          <div id="iKnow">
            <yd-button @click.native="toMain" size="large" type="primary">确定</yd-button>
          </div>
        </div>
      </div>

      <yd-popup v-model="showTime" position="bottom" height="400px">
        <yd-checklist align="right" v-model="form.school" v-for="(item, index) in timeData" :key="index">
          <div style="height: 50px; line-height: 50px; color: black" @click="timeChecked(item)">
            {{ item }}年
          </div>
        </yd-checklist>
      </yd-popup>
    </div>

    <van-popup title v-model="showChooseNew" position="bottom" safe-area-inset-bottom @close="cancelChoose">
      <span v-show="showArea">
        <areaView :visible.sync="showArea" :need="2" :columnsNum="2" @confirm="confirmArea" @cancel="cancelChoose">
        </areaView>
      </span>

      <span v-if="showSchoolNew">
        <school :visible.sync="showSchoolNew" :selectedArea="selectedArea" @confirm="confirmSchool"
          @cancel="cancelChoose"></school>
      </span>
    </van-popup>
  </div>
</template>

<script>
import agreement from "@/components/agreementNew";
import areaView from "@/components/area";
import school from "@/components/school";
export default {
  name: "BindAlert",
  data() {
    return {
      loading: null,
      selectedArea: null,
      selectedSchool: null,
      showChooseNew: false,
      showArea: false,
      showSchoolNew: false,
      showAgreement: false,
      proChose: false, // 选择省
      showProv: false,
      showSchool: false,
      showTime: false,
      provice: "",
      city: "",
      school: "",
      timeData: [],
      schData: [],
      addData: [],
      cityData: [],
      form: {
        addr: {
          pro: [],
          city: [],
        },
        joinTime: "",
      },
      agreeShareContact: true,
      gaoxiao: false,
      verifiFlag: 60,
      telNum: "",
      verifiCode: "",
      isGetPhone: false,
      phoneAnimate: false,
      type: 1,
      getOwnMes: false,
    };
  },
  components: { agreement, areaView, school },
  created() {
    this.getTime();
  },
  mounted: function () {
    var that = this;
    this.userIs();
  },
  methods: {
    confirmArea(data) {
      this.selectedArea = data;
      console.log(this.selectedArea);
      this.showSchoolNew = true;
      this.showArea = false;
    },

    confirmSchool(data) {
      console.log(data, this.selectedArea);
      if (data.Schoolname == "其它") {
        data.Province = this.selectedArea[0].name;
        data.Provinceid = this.selectedArea[0].code;
        data.City = this.selectedArea[1].name;
        data.Cityid = this.selectedArea[1].code;
        //  this.selectedArea
      }
      this.selectedSchool = data;

      console.log(this.selectedSchool);
      this.cancelChoose();
    },
    cancelChoose() {
      console.log("zjl");
      this.showSchoolNew = false;
      this.showArea = false;
      this.showChooseNew = false;
    },

    getTime: function () {
      // 获取年限
      var toDay = new Date();
      var toyear = parseInt(toDay.getFullYear());
      var i = 2020;
      for (i; i <= toyear; i++) {
        this.timeData.push(i);
      }
    },

    choseTime: function () {
      this.showTime = true;
    },

    timeChecked: function (a) {
      // 选择时间
      this.form.joinTime = a;
      this.showTime = false;
    },
    toMain: function () {
      this.$router.push({ name: "video", query: {} });
    },

    userIs: function () {
      var that = this;
      that.axios.get("/api/user/info").then((res) => {
        if (res.data && res.data.code == 0) {
          this.$setUserInfo(res.data.data);
          if (!res.data.data.phone || res.data.data.phone == "") {
            that.isGetPhone = false;
          } else {
            that.telNum = res.data.data.phone;
            if (!res.data.data.isWorker) {
              // 不是高校对接人
              if (!res.data.data.hasExtend) {
                // 没有扩展信息
                that.isGetPhone = true;
              } else {
                that.isGetPhone = true;
              }
            } else {
              // 是高校对接人
              that.gaoxiao = true;
              if (lycamWeb.getCookie("_redirecturl")) {
                lycamWeb.toRedirect();
              } else {
                setTimeout(() => {
                  that.gaoxiao = false;
                  that.$router.push({ name: "video", query: {} });
                }, 2500);
              }
            }
          }
        }
      });
    },
    myalert: function () {
      this.gaoxiao = true;
    },
    checkdata() {
      let that = this;
      if (!this.selectedSchool || !this.selectedSchool.Schoolname) {
        that.$toast("请先选择高中..");
        return false;
      }
      if (!this.form.joinTime) {
        that.$toast("请选择高中入学年份");
        return false;
      }
      that.form.School = this.selectedSchool.Schoolname;
      that.form.Provinceid = this.selectedSchool.Provinceid;
      that.form.Schoolid = this.selectedSchool.Id;
      that.form.Cityid = this.selectedSchool.Cityid;
      that.form.Areaid = this.selectedSchool.Areaid;
      that.form.addr =
        this.selectedSchool.Province +
        (this.selectedSchool.City ? "-" + this.selectedSchool.City : "") +
        (this.selectedSchool.Area ? "-" + this.selectedSchool.Area : "");
      that.form.Enrollmentyear = parseInt(that.form.joinTime); // 入学年份
      that.form.Address = that.form.addr; // 所在地区
      that.form.code = that.verifiCode;
      that.form.Phone = that.telNum;
      that.form.Agreesharecontact = that.agreeShareContact ? 1 : 0;
      that.form.From = that.$store.state.ClickStream;
      if (!this.form.School) {
        that.$toast("请选择学校");
        return false;
      }
      console.log(this.form);
      return true;
    },
    // 绑定用户电话
    bindPhone: function () {
      let that = this;
      if (this.isGetPhone) {
        return;
      }
      if (this.$store.state.RegisterPhone !== 3) {
        if (!(this.telNum && lycamWeb.isPoneAvailable(this.telNum))) {
          that.$toast("请输入正确的手机号码");
          return;
        }
        if (!this.verifiCode) {
          that.$toast("请输入验证码");
          return;
        }
        if (!this.verifiCode) {
          that.$toast("请输入验证码");
          return;
        }
        if (this.verifiCode.length != 4) {
          that.$toast("验证码长度为4位");
          return;
        }
        // if (!this.agreeShareContact) {
        //   that.$toast("请勾选同意书");
        //   return;
        // }
      }

      if (!this.checkdata()) {
        return;
      }
      if (
        this.$store.state.RegisterPhone === 1 ||
        this.$store.state.RegisterPhone === 4
      ) {
        this.loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.axios.post("/api/user/extend/add", this.form).then((res) => {
          setTimeout(() => {
            this.loading.close();
          }, 500);
          console.log(res);
          if (res.data.code == 0) {
            setTimeout(function () {
              that.$Register(2);
              that.$closeBind();
            }, 1000);
            lycamWeb.setCookie("userInfo", res.data.data, 15);
            lycamWeb.setCookie("phone", this.telNum);
            that.$setUserInfo(res.data.data);
            that.$UserRegister();
            that.userIs();
          } else if (res.data.code == 803) {
            that.$toast(res.data.msg);
            setTimeout(function () {
              that.$Register(2);
              that.$closeBind();
            }, 1000);
          } else {
            that.$toast(res.data.msg);
          }
        });
      } else if (this.$store.state.RegisterPhone === 3) {
        this.axios.post("/api/user/extend/update", this.form).then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            lycamWeb.setCookie("phone", this.telNum);
            setTimeout(function () {
              that.$Register(2);
              that.$closeBind();
            }, 1000);
            that.userIs();
          } else {
            that.$toast(res.data.msg);
          }
        });
      }
    },

    // 验证码
    getVerification: function () {
      let that = this;
      if (!(this.telNum && lycamWeb.isPoneAvailable(this.telNum))) {
        that.$toast("请输入正确的手机号码");
        return;
      }
      this.flagReduce();
      let params = {
        Phone: this.telNum,
      };
      this.axios.post("/api/user/phone/sms", params).then(function (res) {
        console.log(res);
        if (res.data.code == 0) {
          //  存储一个信息 已经填写了手机号码
          return;
        } else {
          that.$toast("系统意外");
          setTimeout(function () {
            //   console.log(789);
            this.$store.state.RegisterPhone = 2;
          }, 1000);
        }
      });
    },

    flagReduce: function () {
      if (this.verifiFlag > 0) {
        this.verifiFlag--;
        setTimeout(() => {
          this.flagReduce();
        }, 1000);
      } else {
        this.verifiFlag = 60;
      }
    },
  },
};
</script>

<style scoped>
.doneMes {
  padding-top: 25%;
  width: 100%;
}

.myInputVal {
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid red;
}

.sele {
  width: 98%;
  margin-top: 10px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 25px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 15px;
  height: 40px;
  line-height: 15px;
  outline: 0;
  padding: 0 10px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: none;
  position: relative;
}

.myChose {
  position: absolute;
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: left;
  top: 0;
  left: 10px;
}

.myup {
  position: absolute;
  width: 40px;
  top: 0;
  right: 0;
}

.choseMes {
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.bindDiv {
  margin: 0;
  padding: 0;
  /* min-height: 666px; */
  height: 100vh;
  font-family: PingFangSC-Regular;
  background: rgba(242, 242, 242, 1);
  overflow: scroll;
}

/*关闭界面*/
.closeOption {
  min-height: 60px;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.closeOption span {
  float: right;
  margin: 26px 16px 10px 0;
  font-family: "微软雅黑";
}

.closeOption span img {
  width: 20px;
}

/*表单部分*/
.phoneDiv {
  /* padding: 30px 30px; */
  padding: 0;
  margin: 0;
}

/*手机号*/
.phoneDiv #phoneNum {
  background-color: white;
  border-radius: 25px;
  width: 100%;
}

.phoneDiv #phoneNum input {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}

.bindTx {
  /* margin-left: 10px; */
  margin-bottom: 15px;
  width: 100%;
  /* padding: 10px; */
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(158, 158, 158, 1);
  line-height: 20px;
}

/*验证码*/
#Verification {
  margin-top: 20px;
  height: 50px;
  border-radius: 25px;
  width: 100%;
  overflow: hidden;
  background: #f2f2f2;
  /*border: 1px solid red;*/
}

#Verification .VerificationInput {
  width: 55%;
  float: left;
  background: white;
  border-radius: 40px;
}

#Verification .VerificationBtn {
  width: 35%;
  height: px;
  background: rgba(102, 135, 255, 1);
  border-radius: 40px;
  float: right;
  font-size: 13px;
  line-height: 40px;
  color: white;
}

/*提交*/
#jionIn {
  padding: 0 37.5px;
  width: 100%;
  margin-top: 20px;
}

#jionIn .yd-btn-block {
  height: 40px;
  margin-top: 0;
  border-radius: 40px;
  background: rgba(102, 135, 255, 1);
}

#iKnow {
  width: 100%;
  margin-top: 25px;
  min-height: 40px;
  /*border: 1px solid red;
		text-align: center;*/
}

#iKnow>.yd-btn-block {
  width: 50%;
  margin: 0 auto;
  height: 40px;
  margin-top: 0;
  border-radius: 40px;
  background: rgba(102, 135, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/ownBindAlert.vue